import { COGNITO_CLIENT_ID, COGNITO_URL, WARRCHIRP_APP_URL } from 'config';
import type { GetUserAuthTokensResponseDTO } from 'declarations/dto/auth';
import { utf8ToBase64 } from 'helpers/string';

import { post } from './api';

export const getTokensByAuthorizationCodeApi = async (
  grantCode: string
): Promise<GetUserAuthTokensResponseDTO> => {
  const data = new URLSearchParams({
    Authorization: `Basic ${utf8ToBase64(COGNITO_CLIENT_ID as string)}`,
    grant_type: 'authorization_code',
    client_id: COGNITO_CLIENT_ID as string,
    code: grantCode,
    redirect_uri: `${WARRCHIRP_APP_URL}/login`,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- URLSearchParams is serializable by Axios
  const response = await post<GetUserAuthTokensResponseDTO>('/oauth2/token', data as any, {
    baseURL: `${COGNITO_URL}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data;
};

export const getTokensByRefreshTokenApi = async (
  refreshToken: string
): Promise<GetUserAuthTokensResponseDTO> => {
  const data = new URLSearchParams({
    Authorization: `Basic ${utf8ToBase64(COGNITO_CLIENT_ID as string)}`,
    grant_type: 'refresh_token',
    client_id: COGNITO_CLIENT_ID as string,
    refresh_token: refreshToken,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- URLSearchParams is serializable by Axios
  const response = await post<GetUserAuthTokensResponseDTO>('/oauth2/token', data as any, {
    baseURL: `${COGNITO_URL}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data;
};
